import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const FileText = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.293 3.293L25.707 9.707C25.894 9.895 26 10.149 26 10.414V27C26 28.104 25.105 29 24 29H8C6.896 29 6 28.104 6 27V5C6 3.896 6.896 3 8 3H18.5861C18.8511 3 19.105 3.105 19.293 3.293ZM8 27H24V11H19C18.448 11 18 10.552 18 10V5H8V27ZM11 17H21C21.552 17 22 17.448 22 18C22 18.552 21.552 19 21 19H11C10.448 19 10 18.552 10 18C10 17.448 10.448 17 11 17ZM10 14C10 14.552 10.448 15 11 15H21C21.552 15 22 14.552 22 14C22 13.448 21.552 13 21 13H11C10.447 13 10 13.448 10 14ZM11 21H21C21.552 21 22 21.448 22 22C22 22.552 21.552 23 21 23H11C10.448 23 10 22.552 10 22C10 21.448 10.448 21 11 21Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default FileText
